var CockpitModule = /** @class */ (function () {
    function CockpitModule() {
    }
    return CockpitModule;
}());
export { CockpitModule };
